<div class="container p-4 p-md-5">
  <div class="d-flex justify-content-end">
    <app-button id="back-desktop" [onlyIcon]="true" [isIcon]="true" [left]="true" [iconName]="'bi bi-arrow-left'"
      [buttonOptions]="backOptions" (buttonClick)="back()">
    </app-button>
  </div>
  <div class="logo-sou-mais-fc-page p-3 text-center">
    <img [src]="logoUrl" alt="Logo" />
  </div>
  <div class="partner-data-main-title mb-4 text-center" [style.color]="labelColor">
    {{ pageTitle }}
  </div>

  <form [formGroup]="memberRegistrationGroup">
    <div class="row">
      <div class="col-lg-6 d-flex align-items-center mb-3">
        <app-checkbox [id]="'isForeigner'" [label]="checkboxLabel"
          formControlName="isForeigner" (ngModelChange)="changeForeigner()">
        </app-checkbox>
        <span>
          Sou Estrangeiro
        </span>
      </div>
    </div>
    <div class="row align-items-end">

  @if (!isForeigner) {
  <div class="col-md-3">
    <app-input-custom [id]="'CPFInputId'" [label]="'CPF'" [mask]="InputMaskTypesEnum.CPF" [placeholder]="'Insira seu CPF'"
      formControlName="loginControl" (blur)="onSearchCPF()">
    </app-input-custom>
  </div>
  <div class="col-md-3">
    <app-input-custom [id]="'dateBirthInputId'" [label]="'Data de Nascimento'" [mask]="InputMaskTypesEnum.DATA"
      [placeholder]="'Informe seu nascimento'" formControlName="birthDate" [dropSpecialCharacters]="false"
      (blur)="onSearchCPF()">
    </app-input-custom>
  </div>
  <div class="col-md-6">
    <app-input [id]="'fullNameInputId'" [type]="InputTypeEnum.NAME" [isUpperCase]="true" [label]="'Nome Completo'"
      [placeholder]="'Insira seu Nome'" formControlName="fullnameControl">
    </app-input>
  </div>
  } @else {
  <div class="col-md-2">
    <app-select-input [id]="'countryInputId'" [label]="'País'" [options]="countriesList" formControlName="countryControl">
    </app-select-input>
  </div>
  <div class="col-md-3">
    <app-input-custom [id]="'CPFInputId'" [label]="'Passaporte'" [placeholder]="'Insira seu Passaporte'"
      formControlName="loginControl">
    </app-input-custom>
  </div>
  <div class="col-md-3">
    <app-input-custom [id]="'dateBirthInputId'" [label]="'Data de Nascimento'" [mask]="InputMaskTypesEnum.DATA"
      [placeholder]="'Informe seu nascimento'" formControlName="birthDate" [dropSpecialCharacters]="false"
      (blur)="onSearchCPF()">
    </app-input-custom>
  </div>
  <div class="col-md-4">
    <app-input [id]="'fullNameInputId'" [type]="InputTypeEnum.NAME" [isUpperCase]="true" [label]="'Nome Completo'"
      [placeholder]="'Insira seu Nome'" formControlName="fullnameControl">
    </app-input>
  </div>
  }
  
  </div>
    <!-- Dados Responsavel -->
    <div class="row" *ngIf="isMinorAge">
      <app-input-custom class="col-md-3" [id]="'CPFResInputId'" [label]="'CPF do Responsável'"
        [mask]="InputMaskTypesEnum.CPF" [placeholder]="'Insira o CPF do Responsável'"
        formControlName="cpfResponsibleControl">
      </app-input-custom>
      <div class="col-12 col-md-6">
        <app-input class="col-md-6" [id]="'fullNameInputId'" [type]="InputTypeEnum.NAME" [isUpperCase]="true"
          [label]="'Nome do Responsável'" [placeholder]="'Insira o Nome do Responsável'"
          formControlName="nameResponsibleControl">
        </app-input>
      </div>
      <app-input-custom class="col-md-3" [id]="'phoneInputId'" [label]="'Telefone do Responsável'"
        [placeholder]="'Insira o telefone do Responsável'" [mask]="InputMaskTypesEnum.PHONE" [phoneKind]="'any'"
        formControlName="phoneResponsibleControl">
      </app-input-custom>
    </div>

    <div class="row">
      <app-select-input class="col-md-3" [id]="'genderInputId'" [label]="'Sexo'" [options]="genderOptions"
        formControlName="genderControl">
      </app-select-input>
      <app-input class="col-md-6" [id]="'emailInputId'" [label]="'Email'" [type]="InputTypeEnum.EMAIL"
        [placeholder]="'Insira seu email'" formControlName="emailControl">
      </app-input>
      <app-input-custom class="col-md-3" [id]="'phoneInputId'" [label]="'Celular'" [placeholder]="'Insira seu celular'"
        [mask]="InputMaskTypesEnum.PHONE" formControlName="phoneControl">
      </app-input-custom>
    </div>
    <div class="row">
      <app-input class="col-md-6" [id]="'passwordInputId'" [label]="'Senha'" [type]="InputTypeEnum.PASSWORD"
        [placeholder]="'Crie sua senha'" formControlName="passwordControl">
      </app-input>
      <app-input class="col-md-6" [id]="'confirmPasswordInputId'" [label]="'Confirmar Senha'"
        [type]="InputTypeEnum.PASSWORD" [placeholder]="'Confirme sua senha'"
        formControlName="confirmPasswordControl">
      </app-input>
    </div>

    <div class="row my-3">
      <div class="col-lg-6 d-flex align-items-center mb-3">
        <app-checkbox [id]="'termsConfirmationInputId'" [label]="checkboxLabel"
          formControlName="termsConfirmationInputId">
        </app-checkbox>
        <span>
          Li e concordo com os <a href="#" (click)="showTermsAndPolicies($event, 'terms')" class="mx-1 fw-bold">termos de uso</a>
          e a <a href="#" class="mx-1 fw-bold" (click)="showTermsAndPolicies($event, 'policies')">política de privacidade</a>
        </span>
      </div>

      <div class="col-lg-6">
        <div class="row">
          <div class="col-md-6 mb-3 d-flex justify-content-center justify-content-md-start">
            <ngx-recaptcha2
              [siteKey]="siteKey"
              [useGlobalDomain]="false"
              formControlName="recaptcha">
            </ngx-recaptcha2>
          </div>

          <div class="col-md-6 mb-3 d-flex justify-content-center justify-content-md-end align-items-center">
            <app-button id="btn-cadastrar"
              [disabled]="memberRegistrationGroup.invalid"
              [buttonOptions]="buttonOptions"
              (buttonClick)="onSubmit()">
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<app-modal [modalTitle]="termsAndPoliciesModalTitle"
  [modalId]="termsAndPoliciesModalId"
  [modalBodyMessage]="termsAndPoliciesModalBodyMessage"
  [size]="'modal-xl'" [showCloseBtn]="false"
  [scrollable]="scrollable">
</app-modal>

<app-modal [modalTitle]="modalTitle" [modalId]="modalId"
  [modalBodyMessage]="modalBodyMessage"
  [scrollable]="true" [showCloseBtn]="false"
  (confirmActionChange)="onModalConfirm($event)">
</app-modal>
